import "./Parcours.css"
import "./Parcours-animations.css"

export default function Parcours() {

    return (
        <>
        
        <section className="section--parcours" id="background">

            <h2>Personal background.</h2>

            <div className="parcours__container">

                <div className="timeline">
    
                    <h3 className="timeline__item timeline__item--year">2024</h3>
                    
                    <div className="timeline__item openclassroom">
                        <h4 className="timeline__title">Web Developer & Integrator </h4>
                        <p className="timeline__blurb">OpenClassRooms</p>
                    </div>
                    
                    <h3 className="timeline__item timeline__item--year">2023</h3>
                    
                    <div className="timeline__item">
                        <h4 className="timeline__title">Business Development Manager</h4>
                        <p className="timeline__blurb">Travel-Insight</p>
                    </div>
                    
                    <h3 className="timeline__item timeline__item--year">2021</h3>
                    
                    <div className="timeline__item">
                        <h4 className="timeline__title">Australia Journey</h4>
                    </div>
                    
                    <h3 className="timeline__item timeline__item--year">2020</h3>
                    
                    <div className="timeline__item">
                        <h4 className="timeline__title">Business Developer</h4>
                        <p className="timeline__blurb">Eventiz Media Group - L'Echo Touristique</p>
                    </div>
                    
                    <h3 className="timeline__item timeline__item--year">2017</h3>
                    
                    <div className="timeline__item">
                        <h4 className="timeline__title">Advertising Sale Manager</h4>
                        <p className="timeline__blurb">Infopro Digital - L'Echo Touristique</p>
                    </div>

                    <h3 className="timeline__item timeline__item--year">2013</h3>
                    
                    <div className="timeline__item">
                        <h4 className="timeline__title">Junior Advertising Sale Manager</h4>
                        <p className="timeline__blurb">Infopro Digital - L'Usine Nouvelle - I&T</p>
                    </div>
                    
                    <div className="timeline__item">
                        <h4 className="timeline__title">1st year of Master's Degree </h4>
                        <p className="timeline__blurb">Marketing & Communication Strategy Manager </p>
                    </div>
                    
                    <h3 className="timeline__item timeline__item--year">2012</h3>
                    
                    <div className="timeline__item">
                        <h4 className="timeline__title">Junior Advertising Sale Manager</h4>
                        <p className="timeline__blurb">GISI - L'Usine Nouvelle </p>
                    </div>
                    
                    <div className="timeline__item">
                        <h4 className="timeline__title">Bachelor Marketing & Communication </h4>
                        <p className="timeline__blurb">Sales & Marketing Development</p>
                    </div>
                    
                    <h3 className="timeline__item timeline__item--year">2011</h3>

                    <div className="timeline__item">
                        <h4 className="timeline__title">Technical-sales</h4>
                        <p className="timeline__blurb">APS Informatique</p>
                    </div>
                    
                    <div className="timeline__item">
                        <h4 className="timeline__title">Advanced technician's certificate (BTS) Technico-commercial</h4>
                    </div>
                    
                    <h3 className="timeline__item timeline__item--year">2009</h3>
                    
                    <div className="timeline__item">
                        <h4 className="timeline__title">High School Diploma (Baccalaureate) </h4>
                        <p className="timeline__blurb">STI (Industry Technologies & Sciences - Speciality : Electronic) </p>
                    </div>
                  
                </div>

            </div>

            <div className="stars">
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
            </div>

        </section>

        
        </>

    )
}